// extracted by mini-css-extract-plugin
export default {"wrapper":"h10Z_17ehZndpxYlkjLk"};